// Auto-generated version file - Do not edit manually
// This file is updated automatically by build.sh script
export const VERSION = '1.0.26';
export const BUILD_DATE = '2025-10-28T04:34:46Z';
export const BUILD_ENV = 'dev';
